import Img, { FluidObject } from "gatsby-image"
import React from "react"
import { css } from "styled-components"
import BreakpointImage, {
  IBreakpointImageVariants,
} from "../../design-system/atoms/breakpoint-image"
import VariantContainer from "../../design-system/atoms/variant-container"
import Breakpoints from "../shared/breakpoints"

interface ISdkProjectsCard {
  fluidPrimary: IBreakpointImageVariants
  fluidLogo?: FluidObject
}

export default function SdkProjectsCard({
  fluidPrimary,
  fluidLogo,
}: ISdkProjectsCard) {
  return (
    <VariantContainer
      variants={[
        css`
          display: flex;
          flex-direction: column;
          align-items: center;
        `,
      ]}
    >
      <VariantContainer
        variants={[
          css`
            width: 99%; // At 100% a single line of pixels overlaps from the next slide
            & > * {
              max-height: 455px;
            }
          `,
          css`
            & > * {
              max-height: 384px;
            }
          `,
          css`
            & > * {
              @media (min-width: ${Breakpoints.lgPlus}) {
                max-height: 512px;
              }
            }
          `,
        ]}
      >
        {fluidPrimary && (
          <BreakpointImage
            imgStyle={{ objectFit: "contain" }}
            imageVariants={fluidPrimary}
          />
        )}
      </VariantContainer>
      <VariantContainer
        variants={[
          css`
            display: block;
            width: 100%;
            & > * {
              max-height: 64px;
            }
            padding: 16px 0;
          `,
          css`
            padding: 32px 0 16px 0;
          `,
          css`
            @media (min-width: ${Breakpoints.lgPlus}) {
              padding: 48px 0 24px 0;
            }
          `,
        ]}
      >
        {fluidLogo && (
          <Img imgStyle={{ objectFit: "contain" }} fluid={fluidLogo} />
        )}
      </VariantContainer>
    </VariantContainer>
  )
}
